import pluralize from 'pluralize'
import { connect } from 'react-redux'
import { actions, jsonApiWrapper } from '@opallabs/wormhole'
import { getWorkflowIdentifiers } from '../PhaseList/helpers/helpers'
import { WorkflowPopover } from '.'

const findWorkflow = (state, props) => {
  let workflow = {}
  const [type, id] = getWorkflowIdentifiers(props)
  const singularType = pluralize.singular(type)

  if (state.jsonApiEntities && state.jsonApiEntities['phase-groups'] && id) {
    const workflows = state.jsonApiEntities['phase-groups']

    if (singularType === 'abstractWorkflow') {
      Object.keys(workflows).forEach((k) => {
        if (state.jsonApiEntities['phase-groups'][k].uuid === id) {
          workflow = jsonApiWrapper({
            data: state.jsonApiEntities['phase-groups'][k],
            state,
          })
        }
      })
    } else {
      Object.keys(workflows).forEach((k) => {
        const currentWorkflow = jsonApiWrapper({ data: workflows[k], state })
        const entityId =
          currentWorkflow &&
          currentWorkflow[singularType] &&
          currentWorkflow[singularType].id
        if ((entityId && entityId.toString()) === id.toString()) {
          workflow = jsonApiWrapper({
            data: state.jsonApiEntities['phase-groups'][workflows[k].id],
            state,
          })
        }
      })
    }
  }

  return {
    ...workflow,
    attachmentId: id,
    workflowType: type,
  }
}

const getPhases = (state, props) => {
  const workflow = findWorkflow(state, props)
  if (workflow && workflow.phases && workflow.phases.length) {
    return workflow.phases
  }
  return []
}

const makeUser = (state, user) => jsonApiWrapper({ data: user, state })

const parseUsers = (state) => {
  if (!state.jsonApiEntities || !state.jsonApiEntities.users) return []
  return Object.keys(state.jsonApiEntities.users).map((userId) =>
    makeUser(state, state.jsonApiEntities.users[userId])
  )
}

const mapStateToProps = (state, props) => {
  const users = parseUsers(state)
  const workflow = findWorkflow(state, props)
  const workflowStarted = workflow.status && workflow.status !== 'new'
  const editing = !workflowStarted
  const contentInRedux =
    (state.jsonApiEntities &&
      state.jsonApiEntities.content &&
      state.jsonApiEntities.content[props.postId]) ||
    {}
  const content =
    jsonApiWrapper({
      state,
      data: contentInRedux,
    }) || {}
  const contentAccountId =
    props.contentAccountId || (content.account && content.account.id)

  return {
    attachmentId: workflow.attachmentId,
    approvalStatuses: props.approvalStatuses || [props.approvalStatus],
    content: { ...contentInRedux, ...props.content },
    contentAccountId: contentAccountId && parseInt(contentAccountId, 10),
    currentUser: state.me,
    editing,
    entitySaveMethod: props.entitySaveMethod,
    isLimitedRole: props.isLimitedRole,
    isTemplate: props.isTemplate,
    isWorkflowLockable: props.isWorkflowLockable,
    lastFrame: state.ws_frames && state.ws_frames.lastFrame,
    loaders: {
      startingWorkflow: state.loaders ? state.loaders.startingWorkflow : false,
    },
    locked: workflow.lock_inherited_phases,
    onStartWorkflow: props.onStartWorkflow,
    people: users,
    phases: getPhases(state, props) || [],
    users,
    workflow,
    workflowLoaded: state.workflowLoaded,
    workflowStarted,
    workflowType: workflow.workflowType,
    workflowValid: workflow.validation_status,
    ws_frames: state.ws_frames,
  }
}

const mapDispatchToProps = (dispatch) => ({
  createApprovalItem: (params) => {
    if (params.itemId) {
      return dispatch(actions.updateWorkflowPhaseItem(params))
    }
    return dispatch(actions.createApproval(params))
  },
  createIntegrationTask: (params) => {
    return dispatch(actions.createIntegrationTask(params))
  },
  createPhase: (params) => {
    return dispatch(actions.createWorkflowPhase(params))
  },
  createPhaseItem: (params) => {
    return dispatch(actions.createWorkflowPhaseItem(params))
  },
  createWorkflow: (params) => {
    dispatch(actions.createWorkflow(params))
  },

  destroyPhase: (params) => {
    return dispatch(actions.destroyPhase(params))
  },
  destroyPhaseItem: (params) => {
    return dispatch(actions.destroyPhaseItem(params))
  },

  getIntegrations: () => {
    dispatch(actions.getIntegrations())
  },

  getWorkflow: (type, identifier, showLoader) => {
    dispatch(actions.getWorkflow(type, identifier, showLoader))
  },
  resendApprovals: (params) => {
    return dispatch(actions.resendApprovals(params))
  },
  resetWSLastFrame: () => {
    dispatch(actions.resetWSLastFrame())
  },
  retractApprovals: (params) => {
    return dispatch(actions.retractApprovals(params))
  },
  sendForApproval: (params) => {
    return dispatch(actions.sendForApproval(params))
  },
  setLoader: (params) => {
    dispatch(actions.setLoader(params))
  },
  startWorkflow: (params) => {
    dispatch(actions.startWorkflow(params))
  },
  toggleWorkflowLock: (params) => {
    dispatch(actions.updateWorkflow(params))
  },
  updatePhase: (params) => {
    return dispatch(actions.updateWorkflowPhase(params))
  },
  updatePhaseItem: (params) => {
    return dispatch(actions.updateWorkflowPhaseItem(params))
  },
})

export const ConnectedWorkflowPopover = connect(
  mapStateToProps,
  mapDispatchToProps
)(WorkflowPopover)

export default ConnectedWorkflowPopover
